export default __webpack_public_path__ + "34a706a6292c45335d0e9af1b74e13ae.png";